/**
 * A segment drawn as a straight line while GraphHopper is asked for the real
 * route — it's drawn faint and dotted until the answer lands, so a plan being
 * edited never reads as walking in straight lines. Pure.
 */

interface LineStringLike {
  lineStringProperties?: { pendingSnap?: boolean; id?: string | null } | null;
}

interface RouteLike {
  lineStrings?: LineStringLike[];
}

/** Flags a freshly drawn provisional line as waiting for its route. */
export function markPendingSnap<L extends LineStringLike>(lineString: L): L {
  if (lineString.lineStringProperties) (lineString.lineStringProperties as any).pendingSnap = true;
  return lineString;
}

export function isPendingSnap(lineString: LineStringLike | null | undefined): boolean {
  return !!lineString?.lineStringProperties?.pendingSnap;
}

/** Whether any segment of any route is still waiting for its route. */
export function isRoutingInProgress(routes: { [key: string]: RouteLike } | null | undefined): boolean {
  return Object.values(routes ?? {}).some(route => (route?.lineStrings ?? []).some(isPendingSnap));
}
